import { PureComponent, ReactNode } from "react";
import { KMainFunctions } from "../../shared/utility/main-functions";
import KuikaTooltip from "../ui-kit/kuika-tooltip/kuika-tooltip";

interface IInputTooltipProps {
  description: string;
  helpLink?: string;
}
interface IInputTooltipState {}

export class InputTooltip extends PureComponent<IInputTooltipProps, IInputTooltipState> {
  constructor(props) {
    super(props);
  }

  getContent = () => {
    const { description, helpLink } = this.props;
    const isMainAI = KMainFunctions.isMainAI();
    if (isMainAI) {
      return null;
    }
    return (
      <div className="kuika-input-tooltip">
        <span className="kuika-input-tooltip__description">{description}</span>
        {!!helpLink && (
          <a href={helpLink} className="kuika-input-tooltip__help-link" target="_blank" rel="noreferrer">
            {" "}
            Learn more
          </a>
        )}
      </div>
    );
  };

  render(): ReactNode {
    const content: ReactNode = this.getContent();
    return (
      <KuikaTooltip content={content ?? ""} position="right">
        {/* Outlined rather than a filled disc: the old one was a solid `#d9d9d9` circle
            with a white glyph inside, drawn for a white card. On the dark theme it read as
            a bright blob with nothing legible in it. Drawn in `currentColor`, it takes the
            tint of whatever row it sits in, in either theme. */}
        <svg
          width="16"
          height="16"
          style={{ visibility: content ? "visible" : "hidden" }}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden={content ? undefined : true}
        >
          <circle cx="10" cy="10" r="7.2" stroke="currentColor" strokeWidth="1.4" />
          <circle cx="10" cy="6.7" r="0.95" fill="currentColor" />
          <path d="M10 9.6V13.6" stroke="currentColor" strokeWidth="1.4" strokeMiterlimit="10" strokeLinecap="round" />
        </svg>
      </KuikaTooltip>
    );
  }
}
